@if ($loading()) {
  <par-progress-spinner
    size="54"
    mode="indeterminate"
    class="justify-self-center"
  ></par-progress-spinner>
} @else {
  <h1
    class="w-full hrp-text-body-18-bold bg-hrp-subtle-200 px-6 desktop:py-3 mobile:py-1 tablet:py-1 rounded-md"
  >
    {{ 'account-help' | transloco }}
  </h1>

  <div
    class="flex flex-col desktop:px-12 desktop:pt-12 tablet:px-12 tablet:pt-6 tablet:pb-12 mobile:px-2 mobile:pt-6 mobile:pb-12 desktop:gap-6 tablet:gap-6 mobile:gap-8"
  >
    <!-- Contacts section -->
    <div data-what="help-contacts">
      <p class="hrp-text-body-bold mb-2">{{ $contactsTitle() | transloco }}</p>
      <ul class="list-disc pl-6 flex flex-col gap-1">
        @for (contact of $contacts(); track contact.labelKey) {
          <li data-what="help-contact-item" [attr.data-which]="contact.labelKey">
            <span class="font-bold">{{ contact.labelKey | transloco }}</span
            >&nbsp;
            @if (contact.type === 'email') {
              <a class="text-hrp-primary-700 underline" [href]="'mailto:' + contact.value">{{
                contact.value
              }}</a>
            } @else {
              {{ contact.value | transloco }}
            }
          </li>
        }
      </ul>
    </div>

    <!-- Video categories -->
    @for (category of $categories(); track category.category) {
      <div data-what="video-category" [attr.data-which]="category.category">
        <h2 class="hrp-text-body-bold desktop:mb-4 tablet:mb-4 mobile:mb-2">
          {{ category.titleKey | transloco }}
        </h2>
        <div
          class="grid desktop:grid-cols-2 tablet:grid-cols-2 mobile:grid-cols-1 desktop:gap-4 tablet:gap-4 mobile:gap-3 max-w-3xl"
        >
          @for (video of category.videos; track video.id) {
            <div data-what="video-card" [attr.data-which]="video.id" class="flex flex-col gap-2">
              @if (video.hasError) {
                <div
                  class="w-full aspect-video rounded-[20px] bg-hrp-subtle-300 flex flex-col items-center justify-center gap-[10px] px-6 text-center"
                  data-what="video-fallback"
                  [attr.data-which]="video.id"
                >
                  <ng-icon name="matErrorRound" size="1.5rem" class="text-hrp-subtle-800" />
                  <p class="hrp-text-body-small text-hrp-subtle-800">
                    {{ 'features.account.help.video-error' | transloco }}
                    @if (video.fallbackUrl) {
                      <a
                        class="text-hrp-primary-700 font-bold underline"
                        [href]="video.fallbackUrl"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-what="video-fallback-link"
                        [attr.data-which]="video.id"
                      >
                        {{ 'features.account.help.video-error-link' | transloco }}
                      </a>
                    }
                  </p>
                </div>
              } @else {
                <video
                  class="w-full aspect-video rounded-lg bg-hrp-subtle-100"
                  [src]="video.src"
                  [title]="video.titleKey | transloco"
                  controls
                  preload="metadata"
                  data-what="video-player"
                  (error)="onVideoError(video.id)"
                ></video>
              }
              <p class="hrp-text-body-emph">{{ video.titleKey | transloco }}</p>
            </div>
          }
        </div>
      </div>
    }

    <!-- FAQs section -->
    <div
      id="faq"
      data-what="faq-section"
      class="flex flex-col desktop:gap-6 tablet:gap-6 mobile:gap-4 desktop:pb-12 tablet:pb-12 mobile:pb-12"
    >
      <h2 class="hrp-text-body-20-bold">
        {{ 'features.account.help.faq-title' | transloco }}
      </h2>
      <div class="flex flex-col gap-4">
        <h3 class="hrp-text-body-bold">
          {{ 'features.account.help.faq-calendar-title' | transloco }}
        </h3>
        <div class="flex flex-col gap-3 pl-6">
          <p class="hrp-text-body-emph">
            {{ 'features.account.help.faq-calendar-question' | transloco }}
          </p>
          <div class="flex flex-col gap-2">
            <p class="hrp-text-body-small">
              {{ 'features.account.help.faq-calendar-answer-1' | transloco }}
            </p>
            <p class="hrp-text-body-small">
              {{ 'features.account.help.faq-calendar-answer-2' | transloco }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
}
